module.exports = __webpack_public_path__ + "cuttingline8.webp?f059c67d018c7165a24f4da857add6fa";